<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> shopping_bag </v-icon>
      <span :class="ui.textHeadline"> Order </span>
      <v-spacer/>
      <GeneralHelp :data="{tag: 'Q1', size: 'icon', title: null}"/>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Order manages a transfer of value between financial units.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <Search :data="{title: 'Order Search', tag: 'Q1'}"/>
        <v-spacer/>
        <GetRegisterListPage :data="{tag: 'K6', tagd: 'Q1', tags: 'Q1', size:'flat'}"
        v-if="this.licenceOK &&
        this.userOK"/>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import Search from "@/data/search/components/Search";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import GeneralHelp from "@/frame/help/components/GeneralHelp";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, licenceFunctions, adminFunctions],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser"])
  },
  components: {
    GetRegisterListPage,
    Search,
    GeneralHelp
  },
  data() {
    return {
      valid: true
    };
  }
};
</script>
